import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
const Material = [
  MatInputModule,
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
];
@Component({
  selector: 'eq-email',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...Material
  ],
  templateUrl: './email.component.html',
  styleUrl: './email.component.scss',
})
export class EmailComponent extends EqBaseComponent implements OnInit{

  @Output('navigateToResetPassword') navigateToResetPassword = new EventEmitter<void>();

  navigateToResetPasswordUrl() {
    this.navigateToResetPassword.emit();
  }
}
